import { connect } from 'react-redux';
import { sendSprintCallRecords } from 'actions/voiceRecords';
import subPage from 'decorators/subPage';
import {
  getSubmitStatus,
  getSprintCallRecordsError,
  getSprintCallRecordsSucceed,
} from 'reducers';
import SubNav from 'components/SubNav';
import SprintCallRecordsForm from 'components/SprintCallRecordsForm';
import VoiceAndSMSRecords from 'components/VoiceAndSMSRecords';

const mapStateToProps = (
  state,
  {
    match: {
      params: { subId },
    },
  },
) => ({
  saveStatus: getSubmitStatus(state, 'sprintCallRecord'),
  TableComponent: SprintCallRecordsForm,
  redirectionLink: `/subscriptions/${subId}/view`,
  title: 'Send Sprint Call and SMS Logs',
  error: getSprintCallRecordsError(state, subId),
  success: getSprintCallRecordsSucceed(state, subId),
  SubNav,
});

const mapDispatchToProps = {
  onSubmitVoice: sendSprintCallRecords,
};

export default subPage(
  connect(mapStateToProps, mapDispatchToProps)(VoiceAndSMSRecords),
);
